import { ServiceUrlsProvider } from '@ori/configuration-manager';
import { EnvironmentProvider } from '@ori/environment';
import { TranslationsProvider } from '@ori/i18n';
import { NovageSkincareAdvisorController } from '@ori/novage-skincare-advisor';
import { jsx as _jsx } from "react/jsx-runtime";
export const App = ({
  currentLanguage,
  tenant,
  staticApiUrl,
  globalApiUrl
}) => /*#__PURE__*/_jsx(ServiceUrlsProvider, {
  serviceUrls: {
    staticApiUrl,
    globalApiUrl
  },
  children: /*#__PURE__*/_jsx(EnvironmentProvider, {
    tenant: tenant,
    children: /*#__PURE__*/_jsx(TranslationsProvider, {
      defaultTranslationsWithNamespaces: {},
      language: currentLanguage,
      translationsWithNamespaces: {},
      children: /*#__PURE__*/_jsx(NovageSkincareAdvisorController, {})
    })
  })
});